<template>
  <li class="nav-item">
    <b-link
      v-b-toggle="'menu_' + link.id"
      class="nav-link"
      data-toggle="collapse"
    >
      <i :class="link.icon"></i>
      <span class="nav-link-text">{{ link.label }}</span>
    </b-link>
    <b-collapse :visible="expand" :id="'menu_' + link.id">
      <ul class="nav nav-sm flex-column">
        <router-link
          v-for="(item, index) in link.childs"
          :key="index"
          :to="{ name: item.name }"
          @click.native="linkClick"
          class="nav-link"
        >
          <template>
            <i :class="item.icon"></i>
            <span class="nav-link-text">{{ item.label }}</span>
          </template>
        </router-link>
      </ul>
    </b-collapse>
  </li>
</template>
<script>
export default {
  name: "sidebar-group-item",
  props: {
    link: {
      type: Object,
      default: () => {
        return {
          name: "",
          path: "",
          childs: []
        };
      },
      description:
        "Sidebar link. Can contain name, path, icon and other attributes. See examples for more info"
    }
  },
  inject: {
    autoClose: {
      default: false
    }
  },
  data() {
    return {
      children: [],
      expand: false
    };
  },
  created() {
    this.checkExpand();
  },
  methods: {
    linkClick() {
      if (
        this.autoClose &&
        this.$sidebar &&
        this.$sidebar.showSidebar === true
      ) {
        // this.$sidebar.displaySidebar(false);
        // this.$sidebar.doPinSidebar(!this.$sidebar.pinSidebar);
      }
    },
    checkExpand() {
      for (let i = 0; i < this.link.childs.length; i++) {
        const menu = this.link.childs[i];
        if (menu.name == this.$route.name) {
          this.expand = true;
          return;
        }
      }
      this.expand = false;
    }
  },
  watch: {
    $route: function() {
      this.checkExpand();
    }
  }
};
</script>
